import _classCallCheck from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mkt-main-website/mkt-main-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import { style } from '../decorators.js';
import { $getModelIsVisible, $renderer, $scene, $tick } from '../model-viewer-base.js';
import { degreesToRadians } from '../styles/conversions.js';
import { numberNode } from '../styles/parsers.js';
// How much the model will rotate per
// second in radians:
var DEFAULT_ROTATION_SPEED = Math.PI / 32;
export var AUTO_ROTATE_DELAY_DEFAULT = 3000;
var rotationRateIntrinsics = {
  basis: [degreesToRadians(numberNode(DEFAULT_ROTATION_SPEED, 'rad'))],
  keywords: {
    auto: [null]
  }
};
var $autoRotateStartTime = Symbol('autoRotateStartTime');
var $radiansPerSecond = Symbol('radiansPerSecond');
var $syncRotationRate = Symbol('syncRotationRate');
var $onCameraChange = Symbol('onCameraChange');
export var StagingMixin = function StagingMixin(ModelViewerElement) {
  var _a, _b, _c;
  var StagingModelViewerElement = /*#__PURE__*/function (_ModelViewerElement, _ref) {
    _inherits(StagingModelViewerElement, _ModelViewerElement);
    var _super = _createSuper(StagingModelViewerElement);
    function StagingModelViewerElement() {
      var _this;
      _classCallCheck(this, StagingModelViewerElement);
      _this = _super.apply(this, arguments);
      _this.autoRotate = false;
      _this.autoRotateDelay = AUTO_ROTATE_DELAY_DEFAULT;
      _this.rotationPerSecond = 'auto';
      _this[_a] = performance.now();
      _this[_b] = 0;
      _this[_c] = function (event) {
        if (!_this.autoRotate) {
          return;
        }
        if (event.detail.source === 'user-interaction') {
          _this[$autoRotateStartTime] = performance.now();
        }
      };
      return _this;
    }
    _createClass(StagingModelViewerElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        _get(_getPrototypeOf(StagingModelViewerElement.prototype), "connectedCallback", this).call(this);
        this.addEventListener('camera-change', this[$onCameraChange]);
        this[$autoRotateStartTime] = performance.now();
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        _get(_getPrototypeOf(StagingModelViewerElement.prototype), "disconnectedCallback", this).call(this);
        this.removeEventListener('camera-change', this[$onCameraChange]);
        this[$autoRotateStartTime] = performance.now();
      }
    }, {
      key: "updated",
      value: function updated(changedProperties) {
        _get(_getPrototypeOf(StagingModelViewerElement.prototype), "updated", this).call(this, changedProperties);
        if (changedProperties.has('autoRotate')) {
          this[$autoRotateStartTime] = performance.now();
        }
      }
    }, {
      key: _ref,
      value: function value(style) {
        this[$radiansPerSecond] = style[0];
      }
    }, {
      key: $tick,
      value: function value(time, delta) {
        _get(_getPrototypeOf(StagingModelViewerElement.prototype), $tick, this).call(this, time, delta);
        if (!this.autoRotate || !this[$getModelIsVisible]() || this[$renderer].isPresenting) {
          return;
        }
        var rotationDelta = Math.min(delta, time - this[$autoRotateStartTime] - this.autoRotateDelay);
        if (rotationDelta > 0) {
          this[$scene].yaw = this.turntableRotation + this[$radiansPerSecond] * rotationDelta * 0.001;
        }
      }
    }, {
      key: "turntableRotation",
      get: function get() {
        return this[$scene].yaw;
      }
    }, {
      key: "resetTurntableRotation",
      value: function resetTurntableRotation() {
        var theta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        this[$scene].yaw = theta;
      }
    }]);
    return StagingModelViewerElement;
  }(ModelViewerElement, (_a = $autoRotateStartTime, _b = $radiansPerSecond, $syncRotationRate));
  _c = $onCameraChange;
  __decorate([property({
    type: Boolean,
    attribute: 'auto-rotate'
  })], StagingModelViewerElement.prototype, "autoRotate", void 0);
  __decorate([property({
    type: Number,
    attribute: 'auto-rotate-delay'
  })], StagingModelViewerElement.prototype, "autoRotateDelay", void 0);
  __decorate([style({
    intrinsics: rotationRateIntrinsics,
    updateHandler: $syncRotationRate
  }), property({
    type: String,
    attribute: 'rotation-per-second'
  })], StagingModelViewerElement.prototype, "rotationPerSecond", void 0);
  return StagingModelViewerElement;
};